import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import SoftTypography from "components/SoftTypography";
import DialogWrapper from "layouts/Flow Designer/components/Titlebar/components/DialogWrapper";
import {
  setChangeFlowVersionDialogOpen,
  setSavedFlow,
  reloadFlow,
  setFlowVersionToUse,
  setFlowIsLoading
} from "redux/actions/flowDesigner/flowsActionCreator";
import { changeFlowVersion } from "api/FlowVersions";
import { useFlexLayout } from "context/AppProvider/FlexLayoutContext";

const ChangeFlowVersionDialog = () => {
  const { changeFlowVersionDialogOpen, flowVersionToUse, currentSavedFlow, isFlowLoading } =
    useSelector((state) => state.designer.flows);
  const dispatch = useDispatch();
  const { closeAllTabsExceptReactflow } = useFlexLayout();

  const handleCloseChangeFlowVersionDialog = () => {
    dispatch(setChangeFlowVersionDialogOpen(false));
  };

  const handleChangeFlowVersion = async () => {
    closeAllTabsExceptReactflow();
    if (flowVersionToUse && currentSavedFlow) {
      dispatch(setFlowIsLoading(true));
      const changeFlowResponse = await changeFlowVersion(
        currentSavedFlow.tenant_id,
        currentSavedFlow.id,
        currentSavedFlow.name,
        flowVersionToUse.version
      );
      if (changeFlowResponse?.isSuccessful) {
        dispatch(setSavedFlow(changeFlowResponse.resultObject));
        dispatch(reloadFlow());
        dispatch(setFlowVersionToUse(changeFlowResponse.resultObject));
        toast.success("Flow version changed successfully");
        dispatch(setFlowIsLoading(false));
      }
    }
    handleCloseChangeFlowVersionDialog();
  };

  return (
    <DialogWrapper
      open={changeFlowVersionDialogOpen}
      closeDialog={handleCloseChangeFlowVersionDialog}
      title="Change Flow Version"
      size="sm"
      onSave={() => handleChangeFlowVersion()}
      isLoading={isFlowLoading}
    >
      <SoftTypography sx={{ fontSize: "1rem" }}>{`Switch to flow version ${
        flowVersionToUse?.version ?? ""
      }?`}</SoftTypography>
    </DialogWrapper>
  );
};

export default ChangeFlowVersionDialog;
